import React from "react"
import step1 from "../../assets/images/about/step1.svg"
import step2 from "../../assets/images/about/step2.svg"
import step3 from "../../assets/images/about/step3.svg"
import step4 from "../../assets/images/about/step4.svg"
import step5 from "../../assets/images/about/step5.svg"
import step6 from "../../assets/images/about/step6.svg"

const PathToOwnership = () => {
  return (
    <div className="row ownership-area">
      <div className="col">
        <h3 className="heading-2">A Simple Path to Ownership</h3>
        <p className="paragraph-2">
          <b>6 </b>simple steps and we'll be with you all the way.
        </p>
        <div className="path-steps">
          <div className="path-step">
            <img src={step1} alt="step icon" />
            <small>Step 01</small>
            <p className="paragraph-3">
              We’ll setup a meeting over the phone, in person or complete our
              digital form - it's your choice
            </p>
          </div>

          <div className="path-step">
            <img src={step2} alt="step icon" />
            <small>Step 02</small>
            <p className="paragraph-3">
              We’ll go through the available loans with you
            </p>
          </div>

          <div className="path-step">
            <img src={step3} alt="step icon" />
            <small>Step 03</small>
            <p className="paragraph-3">We’ll help you with the paperwork</p>
          </div>

          <div className="path-step">
            <img src={step4} alt="step icon" />
            <small>Step 04</small>
            <p className="paragraph-3">We’ll guide you from start to finish</p>
          </div>

          <div className="path-step">
            <img src={step5} alt="step icon" />
            <small>Step 05</small>
            <p className="paragraph-3">
              Then it’s time to sign your loan contract
            </p>
          </div>

          <div className="path-step">
            <img src={step6} alt="step icon" />
            <small>Step 06</small>
            <p className="paragraph-3">
              We’re there for you, whenever you need us
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PathToOwnership
